import { useEffect, useState } from "react";
import { projectAuth, projectFirestore } from "../../firebase-config/config";
import { useAuthContext } from "./useAuthContext";

export const useLogout = () => {
  const [isCancelled, setIsCancelled] = useState(false);
  const [error, setError] = useState(null);
  const [isPending, setIsPending] = useState(false);
  const { dispatch } = useAuthContext();

  const logout = async () => {
    setError(null);
    setIsPending(false);

    try {
      // update online status
      const { phoneNumber } = projectAuth.currentUser;
      const formattedPhoneNumber = phoneNumber.slice(1); //remove + from starting of phone

      await projectFirestore
        .collection("users")
        .doc(formattedPhoneNumber)
        .update({ online: false });

      // sign the user out
      await projectAuth.signOut();

      // dispatch logout action
      dispatch({ type: "LOGOUT" });

      // update state
      if (!isCancelled) {
        setIsPending(false);
        setError(null);
      }
    } catch (err) {
      if (!isCancelled) {
        setError(err.message);
        setIsPending(false);
      }
    }
  };

  useEffect(() => {
    return () => setIsCancelled(true);
  }, []);

  return { logout, error, isPending };
};
